module.exports = __webpack_public_path__ + "img/role.ad863c24.png";